module.exports = __webpack_public_path__ + "img/22.7df76ea0.png";